// 长宽比对应 width/height 的 map
export const aspectRatioMap = {
  // 以1080P为基准，保证长宽为偶数
  '21:9': { width: 1792, height: 768 }, // 21:9 等比放大，取接近1080高度的偶数
  '16:9': { width: 1920, height: 1080 }, // 标准1080P
  '4:3': { width: 1440, height: 1080 },  // 4:3 等比放大，高度1080，宽度取偶数
  '9:16': { width: 608, height: 1080 },  // 9:16 等比放大，高度1080，宽度取偶数
  '3:4': { width: 810, height: 1080 },   // 3:4 等比放大，高度1080，宽度取偶数
  '1:1': { width: 1080, height: 1080 },  // 1:1 等比放大，高度1080，宽度取偶数
} as const;

export const aspectRatio720PMap = {
  // 以720P为基准，保证长宽为偶数
  '21:9': { width: 1280, height: 576 }, // 21:9 等比放大，取接近720高度的偶数
  '16:9': { width: 1280, height: 720 }, // 标准720P
  '4:3': { width: 960, height: 720 },  // 4:3 等比放大，高度720，宽度取偶数
  '9:16': { width: 480, height: 720 },  // 9:16 等比放大，高度720，宽度取偶数
  '3:4': { width: 648, height: 720 },   // 3:4 等比放大，高度720，宽度取偶数
  '1:1': { width: 720, height: 720 },  // 1:1 等比放大，高度720，宽度取偶数
};

export const aspectRatio480PMap = {
  // 以480P为基准，保证长宽为偶数
  '21:9': { width: 854, height: 480 }, // 21:9 等比放大，取接近480高度的偶数
  '16:9': { width: 854, height: 480 }, // 标准480P
  '4:3': { width: 648, height: 480 },  // 4:3 等比放大，高度480，宽度取偶数
  '9:16': { width: 480, height: 480 },  // 9:16 等比放大，高度480，宽度取偶数
  '3:4': { width: 480, height: 648 },   // 3:4 等比放大，高度480，宽度取偶数
  '1:1': { width: 480, height: 480 },  // 1:1 等比放大，高度480，宽度取偶数
};

export const aspectRatio360PMap = {
  // 以360P为基准，保证长宽为偶数
  '21:9': { width: 640, height: 360 }, // 21:9 等比放大，取接近360高度的偶数
  '16:9': { width: 640, height: 360 }, // 标准360P
  '4:3': { width: 480, height: 360 },  // 4:3 等比放大，高度360，宽度取偶数
  '9:16': { width: 360, height: 360 },  // 9:16 等比放大，高度360，宽度取偶数
  '3:4': { width: 360, height: 480 },   // 3:4 等比放大，高度360，宽度取偶数
  '1:1': { width: 360, height: 360 },  // 1:1 等比放大，高度360，宽度取偶数
};
